import { render, staticRenderFns } from "./IndexInfo.vue?vue&type=template&id=2d772507&scoped=true&"
import script from "./IndexInfo.vue?vue&type=script&lang=js&"
export * from "./IndexInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d772507",
  null
  
)

export default component.exports